import { Grid } from '@mantine/core';
import XSkeleton1Fields from '../../x-components/x-skeletons/x-skeleton-1-fields.component';
import XSkeleton2Fields from '../../x-components/x-skeletons/x-skeleton-2-fields.component';
import XSkeleton4Fields from '../../x-components/x-skeletons/x-skeleton-4-fields.component';

function SkeletonViewAllPOSInfo(props: Props) {
  const { skeletonHeight, skeletonWidth } = props;
  const height = skeletonHeight ?? 14;
  const width = skeletonWidth ?? '100%';

  const labels = {
    partner: 'Partner',
    reseller: 'Reseller',
    merchant: 'Merchant',
    branch: 'Branch',
    activationCode: 'Activation code',
    activationStatus: 'Activation status',
    activationDate: 'Activation date',
    authPass: 'Auth pass',
    secretKey: 'Secret key',
    posName: 'POS name',
    isActive: 'Active status',
  };

  return (
    <>
      <Grid>
        <XSkeleton4Fields />
        <XSkeleton4Fields />
        <XSkeleton1Fields />
        <XSkeleton2Fields />
      </Grid>
    </>
  );
}

interface Props {
  skeletonHeight?: number;
  skeletonWidth?: number | string;
}

export default SkeletonViewAllPOSInfo;
